// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"6b1e9faa","494":"6a3747b6","816":"9a567d0c"}[chunkId] + ".css";
};